import { PASTA_QUERY } from '../data/pasta-query'
import { useQuery } from '@apollo/client'
import { useParams } from 'react-router'
import { GetItemsPorPastaQuery, GetPastaQuery } from '@/core/types/graphql'
import { ITEMS_POR_PASTA_QUERY } from '../data/items-pasta-query'

export const useBibliotecaQueries = () => {
  const params = useParams()

  const { data: getPasta = {}, loading: loadingPasta } =
    useQuery<GetPastaQuery>(PASTA_QUERY, {
      variables: {
        idPasta: params.idPasta
      },
      skip: !params.idPasta
    })

  const { data: { itemsPorPasta = {} } = {}, loading: loadingItemsPorPasta } =
    useQuery<GetItemsPorPastaQuery>(ITEMS_POR_PASTA_QUERY, {
      variables: {
        idPasta: params.idPasta
      },
      fetchPolicy: 'network-only'
    })

  return {
    getPasta,
    loadingPasta,
    itemsPorPasta,
    loadingItemsPorPasta
  }
}
